import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
/** Mock HTML letter-pop / step-letter animációhoz */
export default function SplitLetters({ text, className = 'step-letter', multiline = false }) {
    if (!multiline) {
        return (_jsx(_Fragment, { children: Array.from(text).map((ch, i) => (_jsx("span", { className: className, style: { ['--i']: i }, children: ch === ' ' ? '\u00a0' : ch }, `${i}-${ch}`))) }));
    }
    const lines = text.split(/\n/);
    let index = 0;
    return (_jsx(_Fragment, { children: lines.map((line, li) => (_jsxs(React.Fragment, { children: [li > 0 ? _jsx("br", {}) : null, Array.from(line).map((ch) => {
                    const i = index++;
                    return (_jsx("span", { className: className, style: { ['--i']: i }, children: ch === ' ' ? '\u00a0' : ch }, `${i}-${ch}`));
                })] }, `line-${li}`))) }));
}
